const piConnectionHu = {
	piConnectionEditForm: 'PI kapcsolat',
	piConnectionTable: 'PI kapcsolat',
	name: 'Név',
	apiUrl: 'API URL',
	username: 'Felhasználónév',
	password: 'Jelszó',
	serverId: 'Szerverazonosító'
};

export default piConnectionHu;
